var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionIconBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311C21 5.28 21 6.12 21 7.8v5.7c0 1.398 0 2.097-.228 2.648a3 3 0 01-1.624 1.624C18.597 18 17.898 18 16.5 18c-.489 0-.733 0-.96.053a2 2 0 00-.821.412c-.18.149-.326.344-.619.735l-1.46 1.947c-.217.29-.326.434-.459.486a.5.5 0 01-.362 0c-.133-.052-.242-.197-.459-.486L9.9 19.2c-.293-.39-.44-.586-.619-.735a2 2 0 00-.821-.412C8.233 18 7.989 18 7.5 18c-1.398 0-2.097 0-2.648-.228a3 3 0 01-1.624-1.624C3 15.597 3 14.898 3 13.5V7.8zm8.488.372A1.248 1.248 0 0113.37 9.25v.002c0 .218-.177.52-.679.854a4.287 4.287 0 01-.879.443l-.008.003a1 1 0 00.634 1.897l-.309-.927.31.926h.002l.003-.002.01-.003.028-.01.093-.034a6.29 6.29 0 001.226-.63c.622-.414 1.569-1.237 1.57-2.517A3.248 3.248 0 009.056 8.17a1 1 0 101.886.664c.098-.278.291-.513.545-.662zm.662 5.328a1 1 0 100 2h.01a1 1 0 100-2h-.01z",
    fill: "#007AFF"
  })));
}

export default SvgQuestionIconBlue;